import { render, staticRenderFns } from "./IkEntityForm.vue?vue&type=template&id=5ffd1e06&scoped=true"
import script from "./IkEntityForm.vue?vue&type=script&lang=js"
export * from "./IkEntityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd1e06",
  null
  
)

export default component.exports